import firebase from 'firebase';
import history from '../history';
import _ from 'lodash';

import {
  STRAINS_FETCH_SUCCESS,
  STRAIN_SELECTED,
  SEARCH_STRAINS,
  REVIEWS_FETCH_SUCCESS,
  STRAIN_FILTER_TYPE,
  STRAIN_FILTER_EFFECT,
  IMAGES_FETCH_SUCCESS,
  REVIEW_COUNT,
  STRAIN_POST_COUNT,
  STRAIN_POST_COUNT_UNMOUNT,
  STRAIN_UNMOUNT
} from './types';

//key magic
function dataToArray(snapshot) {
  const returnArr = [];
  snapshot.forEach((childSnapshot) => {
    const item = childSnapshot.val();
    item.key = childSnapshot.key;
    returnArr.push(item);
  });
  return returnArr.sort();
}

export const fetchStrains = (currentStrains, lastKey) => {
  if (!lastKey) {
    return (dispatch) => {
      firebase
        .database()
        .ref('/strainsMin')
        .orderByKey()
        .limitToFirst(15)
        .once('value', (snapshot) => {
          const strainArray = dataToArray(snapshot);
          const createLastKey = strainArray[strainArray.length - 1].key;
          dispatch({
            type: STRAINS_FETCH_SUCCESS,
            payload: strainArray,
            key: createLastKey,
          });
        });
    };
  }
  return (dispatch) => {
    firebase
      .database()
      .ref('/strainsMin')
      // .orderByKey()
      // .startAt(`${lastKey}`)
      .orderByKey()
      .startAfter(lastKey)
      .limitToFirst(16)
      .once('value', (snapshot) => {
        const strainArray = dataToArray(snapshot);
        if (strainArray.length === 0) {
          dispatch({
            type: STRAINS_FETCH_SUCCESS,
            payload: currentStrains,
            key: undefined,
          });
          return null;
        } else {
          const createLastKey = strainArray[strainArray.length - 1].key;
          const concatStrains = _.concat(currentStrains, strainArray);
          dispatch({
            type: STRAINS_FETCH_SUCCESS,
            payload: concatStrains,
            key: createLastKey,
          });
        }
      });
  };
};

export const filterByType = (type, currentStrains, lastKeyType) => {
  // alert(type)
  if (!lastKeyType) {
    return (dispatch) => {
      firebase
        .database()
        .ref('/strainsMin')
        .orderByChild(type)
        .startAt(true)
        .limitToFirst(15)
        .once('value', (snapshot) => {
          const strainArray = dataToArray(snapshot);
          const createLastKey = strainArray[strainArray.length - 1].key;
          dispatch({
            type: STRAIN_FILTER_TYPE,
            payload: strainArray,
            key: createLastKey,
          });
        });
    };
  }
  return (dispatch) => {
    firebase
      .database()
      .ref('/strainsMin')
      .orderByChild(type)
      .startAfter(true, `${lastKeyType}`)
      .limitToFirst(16)
      .once('value', (snapshot) => {
        const strainArray = dataToArray(snapshot);
        if (strainArray.length === 0) {
          dispatch({
            type: STRAIN_FILTER_TYPE,
            payload: currentStrains,
            key: undefined,
          });
          return null;
        } else {
          const createLastKey = strainArray[strainArray.length - 1].key;
          const concatStrains = _.concat(currentStrains, strainArray);
          dispatch({
            type: STRAIN_FILTER_TYPE,
            payload: concatStrains,
            key: createLastKey,
          });
        }
      });
  };
};
export const filterByEffect = (effectVal, currentStrains, lastKeyEffects) => {
  if (!lastKeyEffects) {
    return (dispatch) => {
      firebase
        .database()
        .ref('/strainsEffects')
        .orderByChild(`effects/${effectVal}`)
        .startAt(true)
        .limitToFirst(15)
        .once('value', (snapshot) => {
          const strainArray = dataToArray(snapshot);
          const createLastKey = strainArray[strainArray.length - 1].key;
          dispatch({
            type: STRAIN_FILTER_EFFECT,
            payload: strainArray,
            key: createLastKey,
          });
        });
    };
  }
  return (dispatch) => {
    firebase
      .database()
      .ref('/strainsEffects')
      .orderByChild(`effects/${effectVal}`)
      .startAfter(true, `${lastKeyEffects}`)
      .limitToFirst(16)
      .once('value', (snapshot) => {
        const strainArray = dataToArray(snapshot);
        if (strainArray.length === 0) {
          dispatch({
            type: STRAIN_FILTER_EFFECT,
            payload: currentStrains,
            key: undefined,
          });
          return null;
        } else {
          const createLastKey = strainArray[strainArray.length - 1].key;
          const concatStrains = _.concat(currentStrains, strainArray);
          dispatch({
            type: STRAIN_FILTER_EFFECT,
            payload: concatStrains,
            key: createLastKey,
          });
        }
      });
  };
};

export const filterByMedical = (medicalVal, currentStrains, lastKeyEffects) => {
  if (!lastKeyEffects) {
    return (dispatch) => {
      firebase
        .database()
        .ref('/strainsMedical')
        .orderByChild(`medical/${medicalVal}`)
        .startAt(true)
        .limitToFirst(15)
        .once('value', (snapshot) => {
          const strainArray = dataToArray(snapshot);
          const createLastKey = strainArray[strainArray.length - 1].key;
          dispatch({
            type: STRAIN_FILTER_EFFECT,
            payload: strainArray,
            key: createLastKey,
          });
        });
    };
  }
  return (dispatch) => {
    firebase
      .database()
      .ref('/strainsMedical')
      .orderByChild(`medical/${medicalVal}`)
      .startAfter(true, `${lastKeyEffects}`)
      .limitToFirst(16)
      .once('value', (snapshot) => {
        const strainArray = dataToArray(snapshot);
        if (strainArray.length === 0) {
          dispatch({
            type: STRAIN_FILTER_EFFECT,
            payload: currentStrains,
            key: undefined,
          });
          return null;
        } else {
          const createLastKey = strainArray[strainArray.length - 1].key;
          const concatStrains = _.concat(currentStrains, strainArray);
          dispatch({
            type: STRAIN_FILTER_EFFECT,
            payload: concatStrains,
            key: createLastKey,
          });
        }
      });
  };
};

export const searchStrains = (text) => {
  // const trimSearch = text.trim();
  return (dispatch) => {
    firebase
      .database()
      .ref('/strainsMin')
      .orderByChild('titleLowercase')
      .startAt(text)
      .endAt(`${text}\uf8ff`)
      .limitToFirst(10)
      .once('value', (snapshot) => {
        const strainArray = dataToArray(snapshot);
        dispatch({ type: SEARCH_STRAINS, payload: strainArray });
      });
  };
};


export const selectStrain = (strain, navigate) => {
  const normalizedStrain = decodeURIComponent(`${strain || ''}`).trim();
  if (!normalizedStrain) {
    return () => null;
  }

  const resolvePayload = (key, data) => ({ ...data, key });
  const routeId = (key, data) => {
    const dataKey = data && data.key;
    const dataTitle = data && data.title;
    return encodeURIComponent(key || dataKey || dataTitle || normalizedStrain);
  };

  return (dispatch) => {
    const strainsRef = firebase.database().ref('/strains/');

    strainsRef
      .child(normalizedStrain)
      .once('value')
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          dispatch({
            type: STRAIN_SELECTED,
            payload: resolvePayload(normalizedStrain, data),
          });
          if (navigate) {
            navigate(`/strains/${routeId(normalizedStrain, data)}`);
          }
          return null;
        }

        return strainsRef
          .orderByChild('titleLowercase')
          .equalTo(normalizedStrain.toLowerCase())
          .limitToFirst(1)
          .once('value')
          .then((querySnapshot) => {
            if (!querySnapshot.exists()) {
              console.error('Unable to find strain:', normalizedStrain);
              return null;
            }
            const key = Object.keys(querySnapshot.val())[0];
            const data = querySnapshot.val()[key];
            dispatch({
              type: STRAIN_SELECTED,
              payload: resolvePayload(key, data),
            });
            if (navigate) {
              navigate(`/strains/${routeId(key, data)}`);
            }
            return null;
          });
      })
      .catch((error) => {
        console.error('Failed to select strain:', error);
      });
  };
};


export const reviewsFetch = (strain) => {
  return (dispatch) => {
    firebase
      .database()
      .ref('reviews/')
      .orderByChild('s')
      .equalTo(strain)
      .once('value', (snapshot) => {
        dispatch({ type: REVIEWS_FETCH_SUCCESS, payload: snapshot.val() });
      });
  };
};

export const imagesFetch = (strainId, fallbackStrainId) => {
  const primaryId = decodeURIComponent(`${strainId || ''}`).trim();
  const secondaryId = decodeURIComponent(`${fallbackStrainId || ''}`).trim();

  if (!primaryId) {
    return (dispatch) => {
      dispatch({ type: IMAGES_FETCH_SUCCESS, payload: null });
    };
  }

  return (dispatch) => {
    const imagesRef = firebase.database().ref('categoriesMin/');

    imagesRef
      .orderByChild('s')
      .equalTo(primaryId)
      .once('value')
      .then((snapshot) => {
        if (snapshot.exists()) {
          dispatch({ type: IMAGES_FETCH_SUCCESS, payload: snapshot.val() });
          return null;
        }

        if (secondaryId && secondaryId !== primaryId) {
          return imagesRef
            .orderByChild('s')
            .equalTo(secondaryId)
            .once('value')
            .then((fallbackSnapshot) => {
              dispatch({
                type: IMAGES_FETCH_SUCCESS,
                payload: fallbackSnapshot.val(),
              });
              return null;
            });
        }

        dispatch({ type: IMAGES_FETCH_SUCCESS, payload: null });
        return null;
      })
      .catch((error) => {
        console.error('Failed to fetch strain images:', error);
        dispatch({ type: IMAGES_FETCH_SUCCESS, payload: null });
      });
  };
};

export const fetchReviewCount = (strainId) => {
  return (dispatch) => {
    firebase
      .database()
      .ref('reviewCount/')
      .child(strainId)
      .once('value', (snapshot) => {
        dispatch({ type: REVIEW_COUNT, payload: snapshot.val() });
      });
  };
};
export const fetchStrainPostsCount = (strainId) => {
  return (dispatch) => {
    firebase
      .database()
      .ref('strainPostCount/')
      .child(strainId)
      .once('value', (snapshot) => {
        dispatch({ type: STRAIN_POST_COUNT, payload: snapshot.val() });
      });
  };
};

export const strainPostCountUnmount = () => {
  return (dispatch) => {
    dispatch({ type: STRAIN_POST_COUNT_UNMOUNT });
  };
};

export const unmountStrains = () => {
  return dispatch => {
    dispatch({ type: STRAIN_UNMOUNT, payload: null });
  };
};
